import * as React from "react";
function SvgCalendar(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40 40"
      ref={svgRef}
      {...props}
    >
      <path d="M33 4h-1V0h-4v4H12V0H8v4H7a5 5 0 00-5 5v26a5 5 0 005 5h26a5 5 0 005-5V9a5 5 0 00-5-5zm1 32H6V14h28z" />
      <path d="M20 22h10v10H20z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgCalendar);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
